import type { ColDef, ValueGetterParams } from "ag-grid-community";
import i18n from "i18next";
import moment from "moment";
import k from "src/i18n/keys";
import type { FormsById } from "src/types";
import { TitleCellRenderer, CreatedByCellRenderer } from "./cellRenderers";
import type { FormDeletionModalSetter } from "./types";

export const getColumns = (
  formsById: FormsById,
  setFormDeletionModal: FormDeletionModalSetter,
): Array<ColDef> => [
  {
    headerName: i18n.t(k.FORM_NAME),
    field: "title",
    flex: 2.8,
    minWidth: 200,
    cellRenderer: TitleCellRenderer,
    cellRendererParams: {
      formsById,
      setFormDeletionModal,
    },
    valueGetter: (params: ValueGetterParams) => {
      if (!params.data?.id) return "";
      const form = formsById[params.data.id];
      return form?.title || "";
    },
    getQuickFilterText: (params) => {
      if (!params.data?.id) return "";
      const form = formsById[params.data.id];
      return form?.title || "";
    },
    sortable: false,
    filter: false,
  },
  {
    headerName: i18n.t(k.CREATED_AT),
    field: "createdAt",
    flex: 1.4,
    minWidth: 150,
    valueGetter: (params: ValueGetterParams) => {
      if (!params.data?.id) return "";
      const form = formsById[params.data.id];
      if (!form?.createdAt) return "";
      const createdAt = form.createdAt;
      const momentDate =
        typeof createdAt === "string"
          ? moment(createdAt)
          : typeof createdAt === "number"
            ? moment.unix(createdAt)
            : moment.unix(Number(createdAt));
      return momentDate.format(i18n.t(k.MMM_DD_YYYY_HH_MM_A));
    },
    getQuickFilterText: () => "",
    sortable: false,
    filter: false,
  },
  {
    headerName: i18n.t(k.UPDATED_AT),
    field: "updatedAt",
    flex: 1.4,
    minWidth: 150,
    valueGetter: (params: ValueGetterParams) => {
      if (!params.data?.id) return "";
      const form = formsById[params.data.id];
      if (!form?.updatedAt) return "";
      const updatedAt = form.updatedAt;
      const momentDate =
        typeof updatedAt === "string"
          ? moment(updatedAt)
          : typeof updatedAt === "number"
            ? moment.unix(updatedAt)
            : moment.unix(Number(updatedAt));
      return momentDate.format(i18n.t(k.MMM_DD_YYYY_HH_MM_A));
    },
    getQuickFilterText: () => "",
    sortable: false,
    filter: false,
  },
  {
    headerName: i18n.t(k.CREATED_BY1),
    field: "creator",
    flex: 1.4,
    minWidth: 150,
    cellRenderer: CreatedByCellRenderer,
    cellRendererParams: {
      formsById,
    },
    valueGetter: (params: ValueGetterParams) => {
      if (!params.data?.id) return "";
      const form = formsById[params.data.id];
      return form?.creator || "";
    },
    getQuickFilterText: () => "",
    sortable: false,
    filter: false,
  },
];
